<template>
  <div>
    <md-card style="min-width:450px;">
      <md-card-header>
        <b-row>
          <b-col>
            <div class="md-title">Contact Us</div>
          </b-col>
          <b-col style="text-align:right">
            <md-button class="md-icon-button md-dense" @click="closeForm">
              <md-icon>highlight_off</md-icon>
            </md-button>
          </b-col>
        </b-row>
      </md-card-header>
      <md-card-content>
        <md-field :class="{ 'md-invalid': emailErr }">
          <label>Your email</label>
          <md-input v-model="inputEmail"></md-input>
          <span class="md-error">{{emailErr}}</span>
        </md-field>

        <md-field :class="{ 'md-invalid': bodyErr }">
          <label>Comments / Questions</label>
          <md-textarea v-model="inputBody"></md-textarea>
          <span class="md-error">{{bodyErr}}</span>
        </md-field>
      </md-card-content>

      <md-card-actions>
        <moow-button
          :loading="loading"
          :type="['light']"
          :btnText="contactSubmitBtnTxt"
          @mClick="contactSales"
        />
      </md-card-actions>
    </md-card>
    <div id="done-overlay">
      <md-icon>done</md-icon>
    </div>
  </div>
</template>

<script>
import Snackbar from "../../components/snackbar.vue";
import moowleContacts from "../../config/moowleContacts.json";
import { attemptSendEmail } from "../../platform/notifications/email/services/emailService";
import { createEmail } from "../../platform/notifications/email/factory/emailFactory";
import { attemptAddLead } from "../../platform/notifications/leads/services/leadService";
import { createLead } from "../../platform/notifications/leads/factory/leadFactory";
import { composeChatRedirectParams } from "../../chatRepository.js";
export default {
  props: {},
  components: {
    "error-snackbar": Snackbar,
  },
  data() {
    return {
      loading: false,
      inputEmail: "",
      inputBody: "",
      contactSubmitBtnTxt: "Submit",
      emailErr: "",
      bodyErr: "",
      rules: {
        emailRule: /.+@.+/,
      },
    };
  },
  computed: {},
  watch: {
    inputEmail(val, oldVal) {
      if (val && val != oldVal) {
        if (this.rules.emailRule.test(val)) this.emailErr = "";
        else this.emailErr = "Invalid email";
      } else this.emailErr = "Required";
    },
    inputBody(newValue, oldValue) {
      if (newValue && newValue != oldValue) this.bodyErr = "";
    },
  },
  created() {
    if (this.$store.getters.user.email)
      this.inputEmail = new String(this.$store.getters.user.email);
  },
  methods: {
    closeForm() {
      this.$emit("closeForm", null);
    },
    contactSales() {
      if (this.validForm()) {
        this.loading = true;
        attemptAddLead(createLead({ email: this.inputEmail }));
        const email = createEmail(
          this.inputEmail,
          moowleContacts.emails.info,
          "Contacting Moowle sales from Web app",
          this.inputBody
        );

        var success
        attemptSendEmail(email)
          .then((resp) => {
            success= true
          })
          .catch((err) => {
            success=false
          })
          .finally((r) => {
            const self = this;
            document.getElementById("done-overlay").style.display = "block";
            setTimeout(function () {
              self.$emit("closeForm", success);
            }, 1000);
            this.inputBody = "";
            this.loading = false;
          });
      }
    },
    validForm() {
      var result = true;
      if (!this.rules.emailRule.test(this.inputEmail)) {
        result = false;
        this.emailErr = "Invalid email";
      }
      if (!this.inputBody) {
        this.bodyErr = "Required field";
        result = false;
      }
      return result;
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
@import "../../assets/styles/booking.css";
@import "../../assets/styles/listings-view.css";

.dead-booking {
  opacity: 0.5;
}

.booking-tenant-name {
  margin: 0 auto;
  margin-top: 1em;
  font-size: 18px;
  cursor: pointer;
  color: blue;
}

.booking-request-content-container {
  padding: 1em;
}

#done-overlay {
  position: absolute;
  background-color: #4899d5;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 999;
  top: 0;
  color: white;
  text-align: center;
}

#done-overlay .md-icon {
  color: white !important;
  top: 45%;
  font-size: 100px !important;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/ContactUsForm.vue